export const settingsIds = ['settings', 'team', 'general'];
